import { useContext, useEffect, useRef } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import { Outlet, useSearchParams } from "react-router-dom";

import i18n from "utils/i18n";

import { AuthTokenContext } from "components/AuthProvider/AuthProviderContext";

export default function PrivateRoute() {
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0();
  const loginCalled = useRef(false);
  const [searchParams] = useSearchParams();

  const token = useContext(AuthTokenContext);

  const langFromParams = searchParams.get("lang");

  useEffect(() => {
    if (langFromParams) {
      localStorage.setItem("ui_locales", langFromParams);
      i18n.changeLanguage(langFromParams);
    }
  }, [langFromParams]);

  const locale = langFromParams || i18n.language;

  useEffect(() => {
    if (!isAuthenticated && !isLoading && !loginCalled.current) {
      loginCalled.current = true;
      loginWithRedirect({
        appState: { returnTo: window.location.pathname },
        authorizationParams: {
          ui_locales: locale,
        },
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, locale]);

  return token && isAuthenticated ? <Outlet /> : null;
}
